import React, { useEffect, useState } from "react";

const LeaderBoard = ({ active }) => {
 const [primaryColor, setPrimaryColor] = useState(active ? "#fff" : (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim())

useEffect(() => {
      setPrimaryColor(active ? "#fff" : (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim())
      
    }, [active])
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="size-6"
      viewBox="0 0 512 511"
      style={{ enableBackground: "new 0 0 512 512" }}
      xmlSpace="preserve"
    >
      <g>
        <path
          d="m193.426 133.527-9.633 56.168a14.998 14.998 0 0 0 5.969 14.672 14.992 14.992 0 0 0 15.797 1.145L256 178.992l50.441 26.52a15.001 15.001 0 0 0 6.98 1.722h.044c8.273-.011 14.976-6.722 14.976-15 0-1.152-.128-2.273-.375-3.351l-9.492-55.356 40.809-39.78a14.997 14.997 0 0 0-8.313-25.582l-56.394-8.196-25.223-51.11a15.004 15.004 0 0 0-26.902 0l-25.223 51.106-56.398 8.195a15.003 15.003 0 0 0-8.313 25.586Zm36.02-45.004a15.001 15.001 0 0 0 11.292-8.207L256 49.395l15.262 30.921a15.014 15.014 0 0 0 11.297 8.207l34.125 4.957-24.696 24.07a14.99 14.99 0 0 0-4.312 13.274l5.828 33.988-30.524-16.046a14.987 14.987 0 0 0-13.957 0L218.5 164.813l5.828-33.985a14.995 14.995 0 0 0-4.312-13.277L195.32 93.48ZM456.832 337.898h-64.266A54.784 54.784 0 0 0 367.398 344v-47.336c0-30.418-24.746-55.164-55.164-55.164H199.766c-30.418 0-55.168 24.746-55.168 55.164v7.168a54.826 54.826 0 0 0-25.164-6.098H55.168C24.746 297.73 0 322.48 0 352.898V497.5c0 8.281 6.715 14.996 15 14.996h482c8.285 0 15-6.715 15-14.996V393.066c0-30.418-24.746-55.168-55.168-55.168ZM30 352.898c0-13.875 11.29-25.168 25.168-25.168h64.266c13.875 0 25.164 11.293 25.164 25.168V482.5H30Zm144.598 0v-56.234c0-13.875 11.293-25.164 25.168-25.164h112.468c13.875 0 25.164 11.29 25.164 25.164V482.5h-162.8ZM482 482.5H367.398v-89.434c0-13.878 11.29-25.168 25.168-25.168h64.266c13.879 0 25.168 11.29 25.168 25.168Zm0 0"
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fillOpacity: 1,
          }}
         fill={primaryColor}
        />
      </g>
    </svg>
  );
};

export default LeaderBoard;
